import { format } from 'date-fns';

export const formatDate = (value) => {
  if (!value) return 'Recently';

  let date;

  if (typeof value?.toDate === 'function') {
    date = value.toDate();
  } else if (typeof value?.seconds === 'number') {
    date = new Date(value.seconds * 1000);
  } else {
    date = new Date(value);
  }

  if (Number.isNaN(date.getTime())) {
    return 'Recently';
  }

  return format(date, 'dd MMM yyyy');
};
